import { useState } from 'react';

const useCollapsiblePanel = (initialCollapsed = false) => {
  const [isCollapsed, setIsCollapsed] = useState(initialCollapsed);

  return {
    isCollapsed,
    collapse: () => setIsCollapsed(true),
    expand: () => setIsCollapsed(false),
  };
};

export default useCollapsiblePanel;
